/** 샵관리 — 반복비용 템플릿. 매달 나가는 고정비를 등록해 두고 월 단위로 일괄 생성한다. */
import React, { useState } from 'react';
import { hiCol } from 'components/grid/hiGrid';
import { ActionButton } from 'styles/common.styles';
import { showAlert } from 'utils/toastBridge';
import ShopGridPage from './ShopGridPage';
import {
  loadTable, persistTable, createUid, num, thisYm, generateMonthlyExpenses, EXP_CATEGORY_OPTIONS, EXP_UTIL_OPTIONS,
} from 'shop/shopStore';
import { ynField } from 'shop/shopPageHelpers';

const GenerateBar = ({ tc }) => {
  const [ym, setYm] = useState(thisYm());
  const run = () => {
    if (!/^\d{6}$/.test(ym)) {
      showAlert('귀속월을 YYYYMM 6자리로 입력하세요.', 'warning');
      return;
    }
    const added = generateMonthlyExpenses(tc, ym);
    showAlert(added ? `${ym} 고정비 ${added}건을 생성했습니다. (월 고정비 화면에서 실제 금액으로 수정)` : '새로 생성할 항목이 없습니다(이미 생성됨).', added ? 'success' : 'info');
  };
  return (
    <div style={{ display: 'flex', gap: 8, alignItems: 'center', margin: '4px 0', fontSize: 12 }}>
      <span>월 일괄생성</span>
      <input value={ym} onChange={(e) => setYm(e.target.value.replace(/\D/g, '').slice(0, 6))} style={{ width: 80, height: 24 }} placeholder="YYYYMM" />
      <ActionButton type="button" onClick={run}>템플릿 → 월 고정비 생성</ActionButton>
      <span style={{ color: '#5b6472' }}>저장된 사용=Y 템플릿 기준, 같은 월에 이미 만든 항목은 건너뜁니다.</span>
    </div>
  );
};

const filter = (rows, v) => rows.filter((r) => r.mod !== 'D' && (!v.useYn || r.useYn === v.useYn));

const cfg = {
  gridId: 'sh-expense-tpl',
  title: '반복비용 템플릿',
  uidKey: 'tplUid',
  searchDefaults: { useYn: 'Y' },
  searchFields: () => [[ynField()]],
  renderTop: ({ tc }) => <GenerateBar tc={tc} />,
  columns: () => [
    hiCol.edComboColumn({ header: '분류', field: 'category', size: 110, required: true, options: EXP_CATEGORY_OPTIONS }),
    hiCol.edComboColumn({ header: '수도광열비 구분', field: 'subCategory', size: 120, options: EXP_UTIL_OPTIONS }),
    hiCol.edNumberColumn({ header: '기본금액', field: 'defaultAmount', size: 110 }),
    hiCol.edNumberColumn({ header: '지급일(일)', field: 'payDay', size: 90, title: '1~28' }),
    hiCol.edCheckboxColumn({ header: '사용', field: 'useYn', size: 72 }),
    hiCol.edTextColumn({ header: '비고', field: 'remark', size: 240 }),
  ],
  load: (tc) => loadTable(tc, 'expenseTpl').map((t) => ({ ...t, mod: '' })),
  filter,
  emptyRow: () => ({ tplUid: createUid('TPL'), category: 'RENT', subCategory: '', defaultAmount: 0, payDay: 25, useYn: 'Y', remark: '' }),
  validate: (rows) => {
    const errors = [];
    for (const r of rows) {
      if (r.mod === 'D') continue;
      if (!r.category) errors.push('분류를 선택하세요.');
      if (r.category === 'UTIL' && !r.subCategory) errors.push('수도광열비는 수도/전기/가스 구분을 선택하세요.');
      if (r.payDay && (num(r.payDay) < 1 || num(r.payDay) > 28)) errors.push('지급일은 1~28 사이입니다.');
    }
    return errors;
  },
  save: (tc, rows, v) => {
    persistTable(tc, 'expenseTpl', 'tplUid', rows, (r) => filter([r], v).length > 0, (r) => ({
      ...r,
      defaultAmount: num(r.defaultAmount),
      payDay: num(r.payDay),
      subCategory: r.category === 'UTIL' ? r.subCategory : '',
      useYn: r.useYn === 'N' ? 'N' : 'Y',
    }));
  },
};

const ExpenseTemplate = () => <ShopGridPage cfg={cfg} />;
export default ExpenseTemplate;
